import { useCallback, useEffect, useState } from 'react';
import { supabase } from '../supabaseClient';

/**
 * G5E — resolve o contexto de relacionamento de um e-mail via RPC
 * resolve_email_relationship_context(p_from_email, p_to_emails, p_cc_emails).
 * Re-resolve quando os endereços mudam (chave estável por join, já que arrays
 * trocam de referência a cada render) ou quando refetch() é chamado após curadoria.
 */
export function useEmailRelationshipContext({ fromEmail, toEmails, ccEmails }) {
  const [context, setContext] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [reloadKey, setReloadKey] = useState(0);

  const refetch = useCallback(() => setReloadKey((k) => k + 1), []);

  // Chave inequívoca (independe da contagem de elementos) — espelha o que vai para a RPC.
  const toKey = JSON.stringify(Array.isArray(toEmails) ? toEmails : toEmails ? [toEmails] : null);
  const ccKey = JSON.stringify(Array.isArray(ccEmails) ? ccEmails : ccEmails ? [ccEmails] : null);

  useEffect(() => {
    let cancelled = false;
    if (!fromEmail) {
      setContext(null);
      setError(null);
      setLoading(false);
      return undefined;
    }
    setLoading(true);
    setError(null);
    supabase
      .rpc('resolve_email_relationship_context', {
        p_from_email: fromEmail,
        p_to_emails: Array.isArray(toEmails) ? toEmails : toEmails ? [toEmails] : null,
        p_cc_emails: Array.isArray(ccEmails) ? ccEmails : ccEmails ? [ccEmails] : null,
      })
      .then(({ data, error: err }) => {
        if (cancelled) return;
        if (err) {
          setError(err.message || String(err));
          setContext(null);
        } else {
          setContext(data || null);
        }
        setLoading(false);
      });
    return () => {
      cancelled = true;
    };
    // toKey/ccKey representam toEmails/ccEmails de forma estável.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fromEmail, toKey, ccKey, reloadKey]);

  return { context, loading, error, refetch };
}
